module.exports = "/images/airplane.png?b918f9c2191e43110ee2e478cf6cf747";


//////////////////
// WEBPACK FOOTER
// ./resources/images/assets2020/airplane.png
// module id = n7Gi
// module chunks = 0